import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";
import {Lib} from "../../../../libs/Lib";
import {ITableListEvent, TableListInputComponent} from "../../table-list-input/table-list-input.component";
import {doNothing} from "../../../common";
import {isNullOrUndefined} from "util";
import {Subscription} from "rxjs";
import * as _ from "lodash";

@Component({
    selector: "app-input",
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss']
})

export class InputComponent implements OnInit, AfterViewInit, OnDestroy {
    field: FieldConfig;
    group: FormGroup;
    colorToggle;
    show = false;
    color;
    public hideMe = false;
    public elementRefs: ElementRef;
    slideValue = 0;
    autoCompleteFilteredOptions: Array<any>;
    autoCompleteOptions: Array<string>;
    unsubs: Array<Subscription> = [];
    m_keyupDebounce;

    @ViewChild('tableList', {read: ElementRef}) tableListsRef;
    @ViewChild('tableList') tableListsComp;
    @ViewChild('slideId', {static: false}) slideRef;

    constructor() {
        this.m_keyupDebounce = _.debounce((e) => {
            this.keyUpNumber(e);
        }, 555);
    }

    ngOnInit() {
        /** Auto complete control **/
        if (this.field.inputType === 'text_autocomplete') {
            this.unsubs.push(
                this.field.observable
                    .subscribe((v) => {
                        this.autoCompleteOptions = v;
                    })
            );
        }

        /** Color control **/
        if (this.field.value && this.field.inputType === 'color') {
            // ** set emit event false, because when label is edited, cursor is moved to forward
            // ** but, need to check more if this changes break existing feature or not.
            this.group.controls[this.field.name]?.setValue(this.field.value, {emitEvent: false, onlySelf: true});
            this.color = this.field.value;

            this.unsubs.push(
                this.group.controls[this.field.name].valueChanges.subscribe(val => {
                    this.color = val;
                })
            );
        }

        /** Base64 control **/
        if (this.field.value && this.field.inputType === 'base64') {
            this.group.controls[this.field.name]?.setValue(Lib.Base64().decode(this.field.value));
        }
    }

    onAutoCompleteFocusLost(e) {
        if (this.field?.callBackValue) {
            this.field.callBackValue(e, 'OUT');
        }
    }

    onAutoCompleteFilter(event) {
        this.autoCompleteFilteredOptions = this.autoCompleteOptions.filter((a) => {
            return a.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
        });
    }

    ngAfterViewInit() {
        if (this.field.inputType === 'tablelist') {
            this.elementRefs = this.tableListsRef;
        }
        setTimeout(() => {
            this.slideValue = this.slideRef?.value;
        });
    }

    getTableListInstance(): TableListInputComponent {
        return this.tableListsComp;
    }

    onKeyNumeric(e) {
        this.m_keyupDebounce(e);
    }

    onTableListUpdate(i_tableList: ITableListEvent) {
        const currentAction = i_tableList.currentAction;
        /** remove all previous currentAction so we can mark only selected currentAction **/
        Object.entries(this.group.value).forEach((items: Array<any>) => {
            items.forEach((val) => {
                if (isNullOrUndefined(val)) return;
                val['currentAction'] ? val['currentAction'] = null : doNothing();
            });
        });
        i_tableList.currentAction = currentAction;
        this.group.get(this.field.name).setValue(i_tableList);
    }

    updateSlider(event) {
        this.slideValue = event.value;
    }

    keyNumberResetValue(event, value) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
        this.group.get(this.field.name).setValue(value);
    }

    onColorChanged(event) {
        this.color = event;
        this.group.get(this.field.name).setValue(event);
    }

    keyUpNumber(e): void {
        // const pattern = /[0-9\+\-\ ]/;
        // const inputChar = String.fromCharCode(event['keyCode']);
        // if (!pattern.test(inputChar)) {
        if (!Lib.IsNumber(e.key)) {
            return;
        }
        if (e.target?.min && e.target?.max && e.target.min !== 'undefined' && e.target.max !== 'undefined') {
            const v = Number(this.group.get(this.field.name).value);
            if (!Lib.IsNumber(v)) {
                this.keyNumberResetValue(e, this.field.minMaxDefault || 1);
                return;
            }
            if (v < e.target.min || v > e.target.max) {
                this.keyNumberResetValue(e, this.field.minMaxDefault || 1);
                return;
            }
        }
    }

    disableInput(i_value) {
        if (i_value) {
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }

    ngOnDestroy() {
        this.m_keyupDebounce = undefined;
        if (this.unsubs.length > 0) {
            this.unsubs.forEach((s) => {
                s.unsubscribe();
            });
        }
    }
}


